import React from 'react';
import { SEGMENT_KING_EVENTS } from 'app/constants/SegmentEvents';
import { useSegmentTracking } from 'app/utils/useSegmentTracking';
import LocationAndAge from 'app/components/customer/Registration/Parts/LocationAndAge';

const Step2 = ({ initialValues, onSubmit, experimentVariant }) => {
  const { trackCompletionEvent } = useSegmentTracking(
    SEGMENT_KING_EVENTS.VIEWED_STATE_SELECTION,
    SEGMENT_KING_EVENTS.COMPLETED_STATE_SELECTION,
  );

  return (
    <LocationAndAge
      experimentVariant={experimentVariant}
      initialValues={initialValues}
      onSubmit={onSubmit}
      trackCompletionEvent={trackCompletionEvent}
    />
  );
};

export default Step2;
